/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data", {cache: "no-store", credentials: "same-origin"})
        .then(response => response.json())
        .catch(function () {
            return {};
        });

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);

    // update the gift bar (markers, progress fill, and message)
    renderGift();

    // show the upsell banner if we're viewing its trigger product
    renderBanner();

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");

        // still render an upsell if one is flagged to show when empty
        renderUpsells();
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        // save supplement data
        const supplementData = cartData[item.key] || {};

        // determine if item has properties
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        function dosesHTML() {
            if (!supplementData.doses) {
                return "";
            }

            const quantity = parseInt(item.quantity, 10) || 1;
            let dosesLabel = supplementData.doses;

            if (typeof dosesLabel === "number") {
                dosesLabel = String(dosesLabel * quantity);
            } else {
                dosesLabel = String(dosesLabel).replace(/\d+/, function (match) {
                    return String(parseInt(match, 10) * quantity);
                });
            }

            return `<div class="miniCartBodyItemDoses">${dosesLabel}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            if (!hasProperties) {
                return "";
            }

            let rows = "";
            for (const key in item.properties) {
                if (!key || key.charAt(0) === "_") {
                    continue;
                }

                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    rows += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                rows += `${key}: ${item.properties[key]}<br>`;
            }

            if (!rows) {
                return "";
            }

            return `<div class="miniCartBodyItemProperties">${rows}</div>`;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (isRestoreLine(item)) {
                return "";
            }
            if (item.selling_plan_allocation) {
                // strip the word "Delivery" from the selling plan name if present
                let sellingPlanName = item.selling_plan_allocation.selling_plan.name.replace(/Delivery/g, "").trim();

                // capitalize the first letter
                sellingPlanName = sellingPlanName.charAt(0).toUpperCase() + sellingPlanName.slice(1);

                const isSupplyPlan = /supply/i.test(sellingPlanName);
                const icon = isSupplyPlan ? "" : `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path fill="#959AB0" d="M4.7663303,7.71248707 L4.7663303,9.31988229 L3.65619285,9.32044226 C4.37964077,10.0063435 5.36614602,10.4285714 6.45352502,10.4285714 C8.10122401,10.4285714 9.51730517,9.45908702 10.1374845,8.07177593 L11.8464124,8.07149775 C11.1547685,10.3433464 9.00204086,12 6.45352502,12 C4.94783296,12 3.58029398,11.4217317 2.5706012,10.4799726 L2.57181978,11.4105949 L1.00039121,11.4105949 L1.00039121,7.71248707 L4.7663303,7.71248707 Z M6.45352502,1 C8.00549297,1 9.41068536,1.61435944 10.428524,2.60788323 L10.4281802,1.42677278 L11.9996088,1.42677278 L11.9996088,5.1248806 L8.2336697,5.1248806 L8.2336697,3.51748538 L9.06882623,3.51720002 C8.3659442,2.92763996 7.45228553,2.57142857 6.45352502,2.57142857 C4.80582602,2.57142857 3.38974487,3.54091298 2.76956555,4.92822407 L1.06063761,4.92850225 C1.75228158,2.65665362 3.90500918,1 6.45352502,1 Z"/></svg>`;

                return `
                    <div class="miniCartBodyItemSellingPlan${isSupplyPlan ? " is-supply" : ""}">
                        ${icon}
                        <div class="miniCartBodyItemSellingPlanTxt">${sellingPlanName}</div>
                    </div>`;
            }
            return "";
        }

        function isProtectSupplyLine() {
            if (!isProtectCartItem(item)) {
                return false;
            }

            const planName = String(item.selling_plan_allocation?.selling_plan?.name || "").toLowerCase();
            return planName.includes("supply");
        }

        // price HTML
        // use line_price (not final_line_price) so cart-level discounts allocated "across" line items are reflected — final_line_price only includes line-level discounts
        function priceHTML() {
            if (!isProtectSupplyLine()) {
                return price(item.line_price, true);
            }

            const monthly = item.selling_plan_allocation.price;
            let otp = 0;
            if (itemTemplate(item) && supplementData.compare_at_price) {
                otp = supplementData.compare_at_price;
            } else {
                otp = (supplementData && supplementData.otp_price) || item.selling_plan_allocation.compare_at_price || 0;
            }
            let html = `<span class="miniCartBodyItemPriceCurrent">${price(monthly, true)}<span class="miniCartBodyItemPriceMo">/mo</span></span>`;
            if (otp > monthly) {
                html += `<span class="miniCartBodyItemPriceCompare">${price(otp, true)}</span>`;
            }
            return html;
        }

        // Title HTML
        function titleHTML() {
            let title = item.product_title;
            if (supplementData.title) {
                title = supplementData.title;
            }
            return title;
        }

        const lockProtectPlanQty = isProtectCartItem(item) && Boolean(item.selling_plan_allocation);

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}" data-lock-qty="${lockProtectPlanQty}">
                <img class="miniCartBodyItemImage" src="${supplementData.image || item.image}&width=200" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${titleHTML()}</div>
                            ${variantHTML()}
                            ${dosesHTML()}
                            ${propertiesHTML()}
                        </div>
                        <div class="miniCartBodyItemPriceRow">
                            <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                            <button class="miniCartBodyItemRemove" type="button" aria-label="Remove">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none" aria-hidden="true">
                                    <path d="M1.5 4h12M5 4V2.75A.75.75 0 0 1 5.75 2h3.5a.75.75 0 0 1 .75.75V4m1.5 0v9.25a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75V4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M6.25 7v4M8.75 7v4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="miniCartBodyItemFlex miniCartBodyItemFlex--meta">
                        <div class="miniCartBodyItemQuantity${lockProtectPlanQty ? " is-locked" : ""}">
                            <button class="miniCartBodyItemQuantityMinus"${lockProtectPlanQty ? " disabled" : ""}>-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus"${lockProtectPlanQty ? " disabled" : ""}>+</button>
                        </div>
                        ${subscriptionHTML()}
                        ${restoreSubscriptionPillHTML(item, supplementData)}
                    </div>
                </div>
                ${protectUpgradeHTML(item, supplementData)}
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        const lockQty = element.dataset.lockQty === "true";

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (lockQty) {
                return;
            }
            if (quantity === 1) {
                quantity = 0;
                updateCartItem();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            if (lockQty) {
                return;
            }
            quantity++;
            updateCartItem();
        });

        element.querySelector(".miniCartBodyItemRemove")?.addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });


        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartProtectUpgrade")?.addEventListener("click", async function (event) {
            event.preventDefault();
            event.stopPropagation();

            const line = cart.items.findIndex(cartItem => cartItem.key === key) + 1;
            const nextQuantity = parseInt(this.dataset.quantity, 10);
            const sellingPlanID = parseInt(this.dataset.plan, 10);
            const subVariantId = parseInt(this.dataset.subVariant, 10);
            const isOtp = this.dataset.isOtp === "1";
            const lineItem = cart.items.find(cartItem => cartItem.key === key);

            if (line < 1 || !nextQuantity || !sellingPlanID) {
                return;
            }

            this.classList.add("loading");
            document.querySelector("#miniCartContent").classList.add("loading");

            try {
                // Wrong product in cart (OTP page product) → swap to subscription product + plan
                if (subVariantId && lineItem && lineItem.variant_id !== subVariantId) {
                    const properties = Object.assign({}, (lineItem.properties) || {});
                    await changeCart({id: key, quantity: 0});
                    await addProduct({
                        items: [{
                            id: subVariantId,
                            quantity: nextQuantity,
                            selling_plan: sellingPlanID,
                            properties: properties
                        }]
                    });
                    await openCart(false);
                    return;
                }

                const result = await changeCart({
                    line: line,
                    quantity: nextQuantity,
                    selling_plan: sellingPlanID
                });
                if (result && Array.isArray(result.items)) {
                    cart = result;
                    await openCart(true);
                } else {
                    await openCart(false);
                }
            } finally {
                document.querySelector("#miniCartContent").classList.remove("loading");
                this.classList.remove("loading");
            }
        });

        // Restore: swap OTP → sub_product + plan; change plan on sub; or re-add as OTP
        element.querySelector(".miniCartRestorePillSelect")?.addEventListener("change", async function () {
            const selectedOption = this.options[this.selectedIndex];
            const sellingPlanID = parseInt(selectedOption.value, 10) || 0;
            const line = cart.items.findIndex(cartItem => cartItem.key === key) + 1;
            const currentPlanId = parseInt(this.dataset.currentPlan, 10) || 0;
            const subVariantId = parseInt(this.dataset.subVariant, 10) || 0;
            const otpVariantId = parseInt(this.dataset.otpVariant, 10) || 0;

            if (line < 1 || sellingPlanID === currentPlanId) {
                return;
            }

            const lineItem = cart.items.find(cartItem => cartItem.key === key);
            if (!lineItem) {
                return;
            }

            document.querySelector("#miniCartContent").classList.add("loading");

            try {
                const properties = Object.assign({}, (lineItem.properties) || {});

                if (!sellingPlanID) {
                    // Prefer OTP from sub_product.metafields.custom.otp_product (data-otp-variant).
                    const otpId = otpVariantId || lineItem.variant_id;
                    await changeCart({id: key, quantity: 0});
                    await addProduct({
                        items: [{
                            id: otpId,
                            quantity: lineItem.quantity,
                            properties: properties
                        }]
                    });
                    await openCart(false);
                    return;
                }

                // One-time (or wrong product) → swap to sub_product + selected plan
                if (subVariantId && lineItem.variant_id !== subVariantId) {
                    await changeCart({id: key, quantity: 0});
                    await addProduct({
                        items: [{
                            id: subVariantId,
                            quantity: lineItem.quantity,
                            selling_plan: sellingPlanID,
                            properties: properties
                        }]
                    });
                    await openCart(false);
                    return;
                }

                const result = await changeCart({
                    line: line,
                    quantity: quantity,
                    selling_plan: sellingPlanID
                });
                if (result && Array.isArray(result.items)) {
                    cart = result;
                    await openCart(true);
                } else {
                    await openCart(false);
                }
            } finally {
                document.querySelector("#miniCartContent").classList.remove("loading");
            }
        });
    });

    // render the single best-matching upsell for the current cart
    renderUpsells();

    let priceHTML = ''
    if (cart.original_total_price > cart.total_price) {
        priceHTML += `<s>${price(cart.original_total_price, true)}</s> `
    }

    // add protection price to ATC button if checked
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        priceHTML += `<span>${price(cart.total_price + cartSettings.protection_upsell.variants[0].price)}</span> `
    } else {
        priceHTML += `<span>${price(cart.total_price, true)}</span> `
    }
    document.querySelector("#miniCartFooterTotalPrice").innerHTML = priceHTML


}

/**************
 Protect upgrade
 ***************/

function isProtectHandle(handle) {
    const value = String(handle || "").toLowerCase().trim();
    return value === "protect" || value === "protect-daily-liver-support";
}

function itemTemplate(item) {
    return String((item.properties || {})._template || "").toLowerCase().trim();
}

function isProtectCartItem(item) {
    const tmpl = itemTemplate(item);
    if (tmpl === "protect-redesign-v1" || tmpl === "protect-redesign-v2" || tmpl === "protect-redesign-v3") {
        return true;
    }
    return isProtectHandle(String(item.handle || "").toLowerCase().trim());
}

function isProtectRedesignLine(item) {
    const tmpl = itemTemplate(item);
    return tmpl === "protect-redesign-v1" || tmpl === "protect-redesign-v2" || tmpl === "protect-redesign-v3";
}

function protectPlanBottles(plan) {
    const name = String((plan && plan.name) || "").toLowerCase();
    const frequency = String((plan && plan.frequency) || "").toLowerCase();
    const source = `${name} ${frequency}`;

    if (source.includes("6-month") || source.includes("6 month")) {
        return 6;
    }
    if (source.includes("3-month") || source.includes("3 month")) {
        return 3;
    }
    if (source.includes("1-month") || source.includes("1 month")) {
        return 1;
    }
    return 0;
}

function protectPlansForItem(item, supplementData) {
    const plans = (supplementData && supplementData.subscription_plans) || [];
    const compareAt = (supplementData && supplementData.compare_at_price) || 0;

    return plans
        .filter(function (plan) {
            return String(plan.name || "").toLowerCase().includes("supply");
        })
        .map(function (plan) {
            const quantity = protectPlanBottles(plan);
            let save = 0;
            if (compareAt > plan.price) {
                save = Math.round((compareAt - plan.price) * 100 / compareAt);
            }
            return {
                id: plan.id,
                name: plan.name,
                quantity: quantity,
                price: plan.price,
                save: save
            };
        })
        .filter(function (plan) {
            return plan.id && plan.quantity > 0;
        });
}

function protectPlanQuantity(item, supplementData) {
    const planId = item.selling_plan_allocation?.selling_plan?.id;
    const matched = protectPlansForItem(item, supplementData).find(plan => plan.id == planId);
    if (matched) {
        return matched.quantity;
    }

    return protectPlanBottles({
        name: item.selling_plan_allocation?.selling_plan?.name,
        frequency: ""
    });
}

function isRestoreLine(item) {
    const tmpl = itemTemplate(item);
    return tmpl === "restore-quiz" || tmpl === "restore-c" || tmpl === "restore-d";
}

function restorePlanLabel(plan) {
    const source = String(plan.frequency || plan.name || "")
        .replace(/[-–—]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    const match = source.match(/(\d+)\s*(weeks?|months?)/i);
    if (match) {
        const unit = match[2].toLowerCase().startsWith("week") ? "weeks" : "months";
        return `Every ${match[1]} ${unit}`;
    }

    return source;
}

function restoreSubscriptionPillHTML(item, supplementData) {
    if (!isRestoreLine(item)) {
        return "";
    }

    const currentPlanId = item.selling_plan_allocation?.selling_plan?.id;
    const isOtp = !currentPlanId;

    // sub_product plans from supplemental data; skip the first plan (historically
    // ReCharge's "Auto-Refill" / every-30-days) as an upsell target, unless it's the
    // plan actually on this line -- otherwise a genuine every-30-days subscriber has
    // no matching <option> and this silently falls back to showing "One-time".
    const allPlans = (supplementData && supplementData.subscription_plans) || [];
    const plans = allPlans.filter(function (plan, idx) {
        return idx !== 0 || plan.id == currentPlanId;
    });
    if (!plans.length) {
        return "";
    }

    const subVariantId = (supplementData && supplementData.subscription_variant_id) || "";
    const otpVariantId = (supplementData && supplementData.otp_variant_id) || item.variant_id || "";
    const planOptions = plans.map(function (plan) {
        const label = restorePlanLabel(plan);
        const selected = !isOtp && plan.id == currentPlanId ? " selected" : "";
        return `<option value="${plan.id}" data-price="${plan.price}"${selected}>${label}</option>`;
    }).join("");
    const options = `<option value=""${isOtp ? " selected" : ""}>One-time</option>${planOptions}`;

    return `
        <div class="miniCartRestoreUpgradePill">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_38_6104)">
            <path d="M11.25 3.125H3.75C3.05964 3.125 2.5 3.68464 2.5 4.375V11.875C2.5 12.5654 3.05964 13.125 3.75 13.125H11.25C11.9404 13.125 12.5 12.5654 12.5 11.875V4.375C12.5 3.68464 11.9404 3.125 11.25 3.125Z" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 1.875V4.375" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 1.875V4.375" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.5 6.875H12.5" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 9.375H5.00667" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.5 9.375H7.50667" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 9.375H10.0067" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 11.25H5.00667" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.5 11.25H7.50667" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 11.25H10.0067" stroke="#545DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_38_6104">
            <rect width="15" height="15" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            <div class="miniCartRestorePillSelectWrap">
                <select class="miniCartRestorePillSelect" data-current-plan="${currentPlanId || ""}" data-sub-variant="${subVariantId}" data-otp-variant="${otpVariantId}">
                    ${options}
                </select>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 5L7.12835 9.58706C7.32697 9.80775 7.67303 9.80775 7.87165 9.58706L12 5" stroke="black" stroke-linecap="round"/>
                </svg>
            </div>
        </div>`;
}


function protectUpgradeHTML(item, supplementData) {
    const planName = String(item.selling_plan_allocation?.selling_plan?.name || "").toLowerCase();
    const isSupply = planName.includes("supply");
    if (!isSupply && !isProtectRedesignLine(item)) {
        return "";
    }

    const plans = protectPlansForItem(item, supplementData)
        .sort((a, b) => a.quantity - b.quantity);
    if (!plans.length) {
        return "";
    }

    const currentQuantity = isSupply ? protectPlanQuantity(item, supplementData) : 0;
    const nextPlan = plans.find(plan => plan.quantity > currentQuantity);

    if (!nextPlan) {
        return "";
    }

    const action = currentQuantity === 0 ? "SUBSCRIBE TO" : "UPGRADE TO";

    return `
        <button class="miniCartProtectUpgrade" type="button" data-quantity="${nextPlan.quantity}" data-plan="${nextPlan.id}" data-sub-variant="${supplementData.subscription_variant_id || ""}" data-is-otp="${item.selling_plan_allocation ? "0" : "1"}">
            <span class="miniCartProtectUpgradeText">${action} ${nextPlan.quantity}-MONTH PLAN &</span>
            <span class="miniCartProtectUpgradeSave">SAVE ${nextPlan.save}%</span>
        </button>`;
}

/**************
 Gift Bar
 ***************/

// render the gift bar
function renderGift() {
    const gift = document.querySelector("#miniCartHeaderGift");
    const bar = document.querySelector("#miniCartHeaderBar");
    const inner = document.querySelector("#miniCartHeaderBarInner");

    // keep every valid tier — a threshold of 0 is allowed and acts as the base "spend more" message
    const tiers = cartGiftData.tiers.filter(tier => Number.isFinite(tier.threshold) && tier.threshold >= 0);

    // guard: no tiers configured — hide the bar and clear the message
    if (tiers.length === 0) {
        gift.classList.remove("active");
        bar.classList.remove("active");
        return;
    }


    // sort ascending so the highest threshold sits at the end of the bar
    const sortedTiers = tiers.sort((a, b) => a.threshold - b.threshold);
    const maxThreshold = sortedTiers[sortedTiers.length - 1].threshold;

    // cart subtotal in cents, matching the tier thresholds (Shopify cart prices are already in cents)
    const subtotal = cart.original_total_price;

    // build every tier marker, positioned as a percentage of the highest threshold
    let markersHTML = "";
    sortedTiers.forEach((tier, index) => {
        const positionPercent = maxThreshold > 0 ? (tier.threshold / maxThreshold) * 100 : 0;

        // optional marker icon (raw SVG/img markup), hidden until the tier is reached
        let iconHTML = "";
        if (tier.image) {
            iconHTML = `<span class="miniCartHeaderBarTierIcon">${tier.image}</span>`;
        }

        // hide first tier
        let markerClass = "miniCartHeaderBarTier";
        if (tier.threshold === 0) {
            markerClass += " hidden";
        }
        if (index === sortedTiers.length - 1) {
            markerClass += " last";
        }

        markersHTML += `
            <div class="${markerClass}" style="left: ${positionPercent}%">
                ${iconHTML}
                <div class="miniCartHeaderBarTierLine"></div>
                <div class="miniCartHeaderBarTierPrice">${price(tier.threshold, true)}</div>
            </div>
        `;
    });

    // wipe any previous markers and lay down the fresh set
    bar.querySelectorAll(".miniCartHeaderBarTier").forEach(element => element.remove());
    bar.insertAdjacentHTML("beforeend", markersHTML);

    // grow the progress fill toward the max threshold (capped at 100%)
    inner.style.width = `${maxThreshold > 0 ? Math.min((subtotal / maxThreshold) * 100, 100) : 100}%`;

    // activate the marker icon for every tier the subtotal has reached
    const markerElements = bar.querySelectorAll(".miniCartHeaderBarTier");
    sortedTiers.forEach((tier, index) => {
        if (subtotal >= tier.threshold) {
            markerElements[index].classList.add("active");
        }
    });

    // empty cart — show the configured empty message and stop
    if (cart.item_count === 0) {
        gift.innerHTML = cartGiftData.empty_message || "";
        return;
    }

    // current tier = the highest tier the subtotal has reached; fall back to the first if none reached yet
    let currentTier = [...sortedTiers].reverse().find(tier => subtotal >= tier.threshold);
    if (!currentTier) {
        currentTier = sortedTiers[0];
    }

    // render the current tier's title and text in their own elements
    gift.innerHTML = `
        <div id="miniCartHeaderGiftTitle">${currentTier.title || ""}</div>
        <div id="miniCartHeaderGiftText">${currentTier.text || ""}</div>
    `;
}

/**************
 Upsells
 ***************/

// pick the single best upsell rule for the current cart and render its products
function renderUpsells() {
    const container = document.querySelector("#miniCartUpsell");
    const body = document.querySelector("#miniCartUpsellBody");

    // always start from a clean slate
    body.innerHTML = "";

    // choose the one winning rule (null if none qualify)
    let winner = null;
    if (cart.item_count === 0) {
        // empty cart — use the first rule flagged to show when empty
        winner = upsellData.find(rule => rule.show_when_empty) || null;
    } else {
        // non-empty cart — keep the rule with the most matched triggers
        let winnerScore = 0;
        upsellData.forEach(rule => {
            // a rule with no triggers can't match anything in a full cart
            if (rule.triggers.length === 0) {
                return;
            }

            // every trigger must be present — the OTP and subscription products represent the same match
            const allMatched = rule.triggers.every(trigger => {
                return cart.items.some(item =>
                    item.product_id === trigger.product_id ||
                    item.product_id === trigger.subscription_product_id
                );
            });

            // a partial match doesn't qualify
            if (!allMatched) {
                return;
            }

            // invalidate the rule if any of its upsell products is already in the cart (OTP or subscription)
            const productInCart = rule.products.some(product => {
                return cart.items.some(item =>
                    item.product_id === product.product_id ||
                    item.product_id === product.subscription_product_id
                );
            });
            if (productInCart) {
                return;
            }

            // keep this rule if it matched more triggers than the current best
            if (rule.triggers.length > winnerScore) {
                winnerScore = rule.triggers.length;
                winner = rule;
            }
        });
    }

    // no qualifying rule, or it has no products, so hide the section unless a banner is overlaying it
    if (!winner || winner.products.length === 0) {
        if (!document.querySelector("#miniCartBanner").classList.contains("active")) {
            container.classList.remove("active");
        }
        return;
    }

    // build a card for every product in the winning rule
    let html = "";
    winner.products.forEach(product => {
        // doses are optional
        let dosesHTML = "";
        if (product.doses) {
            dosesHTML = `<div class="miniCartUpsellBodyItemDoses">${product.doses}</div>`;
        }

        // subscription button only renders when a subscription variant exists
        let subButtonHTML = "";
        if (product.subscription_variant_id) {
            subButtonHTML = `
                <button class="miniCartUpsellBodyItemATC button sub" data-variant="${product.subscription_variant_id}" data-plan="${product.selling_plan_id}">
                     <svg class="collectionItemButtonsItemIcon" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M7.89891 12.3187V14.7298L6.2337 14.7307C7.31887 15.7595 8.79863 16.3929 10.4297 16.3929C12.9012 16.3929 15.0254 14.9386 15.9556 12.8577L18.519 12.8572C17.4816 16.265 14.2525 18.75 10.4297 18.75C8.17116 18.75 6.11985 17.8826 4.60531 16.47L4.60714 17.8659H2.25V12.3187H7.89891ZM10.4297 2.25C12.7577 2.25 14.8654 3.17154 16.3922 4.66182L16.3917 2.89016H18.7488V8.43732H13.0999V6.02623L14.3527 6.0258C13.2983 5.14146 11.9278 4.60714 10.4297 4.60714C7.95815 4.60714 5.83403 6.06137 4.90376 8.14234L2.34037 8.14275C3.37784 4.73498 6.60693 2.25 10.4297 2.25Z" fill="#252525"/>
                      </svg>
                    Ship monthly for ${price(product.subscription_price, true)}
                </button>
            `;
        }

        html += `
            <div class="miniCartUpsellBodyItem">
                <img class="miniCartUpsellBodyItemImage" src="${product.image}&width=200" alt="${product.title}">
                <div>
                    <div class="miniCartUpsellBodyItemFlex">
                        <div>
                            <div class="miniCartUpsellBodyItemTitle">${product.title}</div>
                            ${dosesHTML}
                        </div>
                    </div>
                    <div class="miniCartUpsellBodyItemFlex col">
                        <button class="miniCartUpsellBodyItemATC button" data-variant="${product.variant_id}" style="background-color: ${product.color}">
                          <svg class="miniCartUpsellBodyItemATCIcon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                <g clip-path="url(#clip0_507_1043)">
                                    <path d="M1.49609 1.49609H4.95209L7.26761 13.0651C7.34662 13.4628 7.56302 13.8202 7.87893 14.0745C8.19484 14.3288 8.59014 14.4639 8.99561 14.4561H17.3937C17.7992 14.4639 18.1945 14.3288 18.5104 14.0745C18.8263 13.8202 19.0427 13.4628 19.1217 13.0651L20.5041 5.81609H5.81609M9.27209 18.7761C9.27209 19.2533 8.88527 19.6401 8.40809 19.6401C7.93092 19.6401 7.54409 19.2533 7.54409 18.7761C7.54409 18.2989 7.93092 17.9121 8.40809 17.9121C8.88527 17.9121 9.27209 18.2989 9.27209 18.7761ZM18.7761 18.7761C18.7761 19.2533 18.3893 19.6401 17.9121 19.6401C17.4349 19.6401 17.0481 19.2533 17.0481 18.7761C17.0481 18.2989 17.4349 17.9121 17.9121 17.9121C18.3893 17.9121 18.7761 18.2989 18.7761 18.7761Z" stroke="white" stroke-width="1.728" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_507_1043">
                                        <rect width="20.736" height="20.736" fill="white" transform="translate(0.631836 0.63208)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                           Add to cart for ${price(product.price, true)}
                        </button>
                        ${subButtonHTML}
                    </div>
                </div>
            </div>
        `;
    });

    // insert once and reveal the section
    body.innerHTML = html;
    container.classList.add("active");
}

// add an upsell product to the cart (delegated — cards are rendered dynamically)
document.querySelector("#miniCartUpsellBody").addEventListener("click", async function (e) {
    const button = e.target.closest(".miniCartUpsellBodyItemATC");
    if (!button) {
        return;
    }

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // build the line item — attach the selling plan only for the subscription button
    const lineItem = {
        quantity: 1,
        id: button.dataset.variant
    };
    if (button.dataset.plan) {
        lineItem.selling_plan = button.dataset.plan;
    }

    // add to cart and re-render
    await addProduct({items: [lineItem]});
    await openCart();
});


/**************
 Banner
 ***************/

// render the upsell banner when viewing its trigger product's page
function renderBanner() {
    const container = document.querySelector("#miniCartBanner");

    // current product handle from the URL, e.g. /products/restore (null off product pages)
    const handleMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    const currentProductHandle = handleMatch ? handleMatch[1] : null;

    // match a banner to the product page we're on, but not if its upsell product is already in the cart
    const data = bannerData.find(item =>
        item.trigger_product_handle === currentProductHandle &&
        !cart.items.some(cartItem => cartItem.product_id === item.product_id || cartItem.product_id === item.sub_product_id)
    );

    const upsell = document.querySelector("#miniCartUpsell");

    // no banner for this page, so clear and hide the overlay
    if (!data) {
        container.innerHTML = "";
        container.classList.remove("active");
        return;
    }

    //If the cart has a subscription trigger product, add the upsell as a subscription
    let activeUpsellId = data.variant_id;
    let sellingPlan = "";
    for (const item of cart.items) {
        if (item.selling_plan_allocation) {
            activeUpsellId = data.sub_variant_id;
            sellingPlan = data.sub_product_selling_plan;
        }
    }

    // price
    let priceHTML = "";
    if (sellingPlan !== "") {
        priceHTML = `<span class="miniCartBannerItemATCPrice">${price(data.sub_price, true)}</span>`;
    } else {
        priceHTML = `<span class="miniCartBannerItemATCPrice">${price(data.price, true)}</span>`;
    }

    // compare price
    let compareHTML = "";
    if (data.compare_price > 0) {
        compareHTML = `<s class="miniCartBannerItemATCCompare">${price(data.compare_price, true)}</s>`;
    }

    // savings
    let savingsHTML = "";
    if (data.savings > 0) {
        if (sellingPlan !== "") {
            savingsHTML = `<span class="miniCartBannerItemATCSavings" style="background-color: ${data.highlight_color}; color: ${data.primary_color}">Save ${price(data.sub_savings, true)}</span>`;
        } else {
            savingsHTML = `<span class="miniCartBannerItemATCSavings" style="background-color: ${data.highlight_color}; color: ${data.primary_color}">Save ${price(data.savings, true)}</span>`;
        }
    }

    // build banner HTML
    container.innerHTML = `
        <div class="miniCartBannerItem" style="background-color: ${data.background_color}">
            <button class="miniCartBannerItemClose">
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
                    <g transform="translate(12 11)" fill="#383838" fill-rule="evenodd">
                        <rect transform="rotate(45 9 9.5)" x="-2" y="8" width="22" height="3" rx="1.5"/>
                        <rect transform="rotate(-45 9 9.5)" x="-2" y="8" width="22" height="3" rx="1.5"/>
                    </g>
                </svg>
            </button>
            <div class="miniCartBannerItemHeader">
                <img class="miniCartBannerItemHeaderImg" src="${data.image}" alt="${data.title}">
                <div class="miniCartBannerItemHeaderBody">
                    <div class="miniCartBannerItemHeaderBodyTitle">${data.title}</div>
                    <div class="miniCartBannerItemHeaderBodySubtitle">${data.subtitle}</div>
                </div>
            </div>
            <div class="miniCartBannerItemTxt">${data.text}</div>
            <button class="miniCartBannerItemATC button" style="background-color: ${data.primary_color};" data-variant="${activeUpsellId}" data-selling-plan="${sellingPlan}">
                <span class="miniCartBannerItemATCText">${data.atc_text}</span>
                ${compareHTML}
                ${priceHTML}
                ${savingsHTML}
            </button>
        </div>
    `;

    // any strong elements inside the title pick up the primary color
    container.querySelectorAll(".miniCartBannerItemHeaderBodyTitle strong").forEach(function (strong) {
        strong.style.color = data.primary_color;
    });

    // reveal the banner and keep the upsell host visible so the overlay grid has somewhere to render
    container.classList.add("active");
    upsell.classList.add("active");
}

// banner clicks (delegated, the card is rendered dynamically)
document.querySelector("#miniCartBanner").addEventListener("click", async function (e) {
    // ATC
    const atc = e.target.closest(".miniCartBannerItemATC");
    if (atc) {
        document.querySelector("#miniCartContent").classList.add("loading");
        const data = {
            items: [
                {
                    quantity: 1,
                    id: atc.dataset.variant,
                }
            ]
        }

        if (atc.dataset.sellingPlan !== "") {
            data.items[0].selling_plan = atc.dataset.sellingPlan;
        }
        await addProduct(data);
        await openCart();
        return;
    }

    // CLOSE
    if (e.target.closest(".miniCartBannerItemClose")) {
        const banner = document.querySelector("#miniCartBanner");
        const item = banner.querySelector(".miniCartBannerItem");
        item.classList.add("closing");
        item.addEventListener("transitionend", function () {
            banner.classList.remove("active");
        }, {once: true});
    }
});

// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}